import React from 'react';

/**
 * 在主站 Layout 内嵌 Studio（创作实验室）
 * 保留主站 Header，Studio 内容以 iframe 形式展示
 */
function StudioEmbed() {
  const studioUrl = `${window.location.origin}/studio/`;

  return (
    <div style={styles.container}>
      <iframe
        src={studioUrl}
        title="蓝卡模玩创作实验室"
        style={styles.iframe}
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
      />
    </div>
  );
}

const styles = {
  container: {
    width: '100%',
    height: 'calc(100vh - 120px)',
    minHeight: 500,
    position: 'relative',
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
    display: 'block',
  },
};

export default StudioEmbed;
